import { Grid } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { DataContext } from '../../data/DataProvider'
import { LicenseInfoSchemaType } from '../../schema/input'
import { LicenseType } from '../../types/interface'
import FileUpload from '../forms/FileUploadWrapper'
import SelectDate from '../forms/SelectDateWrapper'
import Select from '../forms/SelectWrapper'
import Textfield from '../forms/TextfieldWrapper'

interface LicenseDocsProps {
  city?: string
  dir: string
  value: { city: number } & LicenseInfoSchemaType
}

const LicenseDocs = ({ city, dir, value }: LicenseDocsProps) => {
  const data = useContext(DataContext)
  const [isLoading, setIsLoading] = useState(true)
  const [licenseArray, setLicenseArray] = useState<LicenseType[]>([])
  const location = useLocation().pathname.substring(8)
  const { t } = useTranslation()

  const getLicenseType = async (cityId: number) => {
    setIsLoading(true)
    await data
      .getCityLicense(cityId)
      .then((response) => {
        setLicenseArray(response)
        setIsLoading(false)
      })
      .catch((error) => console.error(error))
  }

  useEffect(() => {
    if (location !== 'documents') {
      getLicenseType(value.city)
    }
  }, [])

  const configGridItem = {
    item: true,
    xs: 12,
  }

  return (
    <Grid
      container
      rowGap={4}
      sx={{
        backgroundColor: '#FAF9F9',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        mb: 2,
        p: 4,
      }}
    >
      <Grid {...configGridItem}>
        <Textfield
          label={t('profile.info.license_plate')}
          name="licenseNumber"
        />
      </Grid>
      {location === 'documents' ? (
        <Grid {...configGridItem}>
          <Textfield
            disabled
            label={t('profile.info.license_type')}
            name="type"
          />
        </Grid>
      ) : (
        <Grid {...configGridItem}>
          {isLoading ? (
            <>Loading Types...</>
          ) : (
            <Select
              label={t('profile.info.license_type')}
              name="type"
              options={licenseArray}
            />
          )}
        </Grid>
      )}
      <Grid {...configGridItem}>
        <SelectDate
          label={t('documents.additional_documents.expiration_date')}
          name="docExpirationDate"
        />
      </Grid>
      <Grid {...configGridItem}>
        <FileUpload
          city={city}
          documentType="document"
          folder={dir}
          label={t('documents.driver_license.front_label')}
          name="front"
          value={value.front}
        />
      </Grid>
      <Grid {...configGridItem}>
        <FileUpload
          city={city}
          documentType="document"
          folder={dir}
          label={t('documents.driver_license.back_label')}
          name="back"
          value={value.back}
        />
      </Grid>
    </Grid>
  )
}

export default LicenseDocs
